import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Text, theme } from 'yolda-web-ui'
import { StyledNotFound } from './NotFound.style'

const NotFound: FC = () => {
  const { t } = useTranslation()

  return (
    <StyledNotFound>
      <section>
        <Text as="h1" mb={theme.spacing.medium}>
          {`${t('errorBoundary.title')}`}
        </Text>
        <Text as="p" mb={theme.spacing.default}>
          {`${t('errorBoundary.desc')}`}
        </Text>
        <Text as="p" mb={theme.spacing.medium}>
          {`${t('errorBoundary.desc2')}`}
        </Text>
        <a href="/">{`${t('errorBoundary.button')}`}</a>
      </section>
    </StyledNotFound>
  )
}

export default NotFound
